import { ReportType } from "../../../types/types";
import { api } from "../api";

/**
 * findAllTravelsWithFiltersResponse - Function that finds on database all travels by filters
 * /reports/maps/trips?ignoreDepartments=${ignoreDepartments}&status=${status}
 * method POST 
 * @async-function
 */
const findAllTravelsWithFiltersResponse = async (token: string, model: ReportType, ignoreDepartments: boolean = false, status: string = "activated") => {
    const response = await api.post(
        `/reports/maps/trips/${status}?ignoreDepartments=${ignoreDepartments}`, { ...model }, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    );
    return response;
};

export default findAllTravelsWithFiltersResponse;
